// Generated from HCPGrammarParser.g4 by ANTLR 4.7.1
// jshint ignore: start
var antlr4 = require('./antlr4/index');

// This class defines a complete listener for a parse tree produced by HCPGrammarParser.
function HCPGrammarParserListener() {
	antlr4.tree.ParseTreeListener.call(this);
	return this;
}

HCPGrammarParserListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
HCPGrammarParserListener.prototype.constructor = HCPGrammarParserListener;

// Enter a parse tree produced by HCPGrammarParser#program.
HCPGrammarParserListener.prototype.enterProgram = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#program.
HCPGrammarParserListener.prototype.exitProgram = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#sourceElement.
HCPGrammarParserListener.prototype.enterSourceElement = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#sourceElement.
HCPGrammarParserListener.prototype.exitSourceElement = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#statement.
HCPGrammarParserListener.prototype.enterStatement = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#statement.
HCPGrammarParserListener.prototype.exitStatement = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#statementList.
HCPGrammarParserListener.prototype.enterStatementList = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#statementList.
HCPGrammarParserListener.prototype.exitStatementList = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#variableStatement.
HCPGrammarParserListener.prototype.enterVariableStatement = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#variableStatement.
HCPGrammarParserListener.prototype.exitVariableStatement = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#ctypeStatement.
HCPGrammarParserListener.prototype.enterCtypeStatement = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#ctypeStatement.
HCPGrammarParserListener.prototype.exitCtypeStatement = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#variableDeclarationList.
HCPGrammarParserListener.prototype.enterVariableDeclarationList = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#variableDeclarationList.
HCPGrammarParserListener.prototype.exitVariableDeclarationList = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#ScalarVariableDeclaration.
HCPGrammarParserListener.prototype.enterScalarVariableDeclaration = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#ScalarVariableDeclaration.
HCPGrammarParserListener.prototype.exitScalarVariableDeclaration = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#ArrayVariableDeclaration.
HCPGrammarParserListener.prototype.enterArrayVariableDeclaration = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#ArrayVariableDeclaration.
HCPGrammarParserListener.prototype.exitArrayVariableDeclaration = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#emptyStatement.
HCPGrammarParserListener.prototype.enterEmptyStatement = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#emptyStatement.
HCPGrammarParserListener.prototype.exitEmptyStatement = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#expressionStatement.
HCPGrammarParserListener.prototype.enterExpressionStatement = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#expressionStatement.
HCPGrammarParserListener.prototype.exitExpressionStatement = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#ifStatement.
HCPGrammarParserListener.prototype.enterIfStatement = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#ifStatement.
HCPGrammarParserListener.prototype.exitIfStatement = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#vartype.
HCPGrammarParserListener.prototype.enterVartype = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#vartype.
HCPGrammarParserListener.prototype.exitVartype = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#sourceElements.
HCPGrammarParserListener.prototype.enterSourceElements = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#sourceElements.
HCPGrammarParserListener.prototype.exitSourceElements = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#expressionSequence.
HCPGrammarParserListener.prototype.enterExpressionSequence = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#expressionSequence.
HCPGrammarParserListener.prototype.exitExpressionSequence = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#ParenthesizedExpression.
HCPGrammarParserListener.prototype.enterParenthesizedExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#ParenthesizedExpression.
HCPGrammarParserListener.prototype.exitParenthesizedExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#AdditiveExpression.
HCPGrammarParserListener.prototype.enterAdditiveExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#AdditiveExpression.
HCPGrammarParserListener.prototype.exitAdditiveExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#RelationalExpression.
HCPGrammarParserListener.prototype.enterRelationalExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#RelationalExpression.
HCPGrammarParserListener.prototype.exitRelationalExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#ArrowPropExpression.
HCPGrammarParserListener.prototype.enterArrowPropExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#ArrowPropExpression.
HCPGrammarParserListener.prototype.exitArrowPropExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#LogicalAndExpression.
HCPGrammarParserListener.prototype.enterLogicalAndExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#LogicalAndExpression.
HCPGrammarParserListener.prototype.exitLogicalAndExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#LiteralExpression.
HCPGrammarParserListener.prototype.enterLiteralExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#LiteralExpression.
HCPGrammarParserListener.prototype.exitLiteralExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#LogicalOrExpression.
HCPGrammarParserListener.prototype.enterLogicalOrExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#LogicalOrExpression.
HCPGrammarParserListener.prototype.exitLogicalOrExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#customFnExpression.
HCPGrammarParserListener.prototype.enterCustomFnExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#customFnExpression.
HCPGrammarParserListener.prototype.exitCustomFnExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#NotExpression.
HCPGrammarParserListener.prototype.enterNotExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#NotExpression.
HCPGrammarParserListener.prototype.exitNotExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#MemberIndexExpression.
HCPGrammarParserListener.prototype.enterMemberIndexExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#MemberIndexExpression.
HCPGrammarParserListener.prototype.exitMemberIndexExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#builtInTimeExpression.
HCPGrammarParserListener.prototype.enterBuiltInTimeExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#builtInTimeExpression.
HCPGrammarParserListener.prototype.exitBuiltInTimeExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#AssetConnectionExpression.
HCPGrammarParserListener.prototype.enterAssetConnectionExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#AssetConnectionExpression.
HCPGrammarParserListener.prototype.exitAssetConnectionExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#UnaryMinusExpression.
HCPGrammarParserListener.prototype.enterUnaryMinusExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#UnaryMinusExpression.
HCPGrammarParserListener.prototype.exitUnaryMinusExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#AssignmentExpression.
HCPGrammarParserListener.prototype.enterAssignmentExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#AssignmentExpression.
HCPGrammarParserListener.prototype.exitAssignmentExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#BitAndExpression.
HCPGrammarParserListener.prototype.enterBitAndExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#BitAndExpression.
HCPGrammarParserListener.prototype.exitBitAndExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#IdentifierRightExpression.
HCPGrammarParserListener.prototype.enterIdentifierRightExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#IdentifierRightExpression.
HCPGrammarParserListener.prototype.exitIdentifierRightExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#BitOrExpression.
HCPGrammarParserListener.prototype.enterBitOrExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#BitOrExpression.
HCPGrammarParserListener.prototype.exitBitOrExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#UnaryPlusExpression.
HCPGrammarParserListener.prototype.enterUnaryPlusExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#UnaryPlusExpression.
HCPGrammarParserListener.prototype.exitUnaryPlusExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#builtInFnExpression.
HCPGrammarParserListener.prototype.enterBuiltInFnExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#builtInFnExpression.
HCPGrammarParserListener.prototype.exitBuiltInFnExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#EqualityExpression.
HCPGrammarParserListener.prototype.enterEqualityExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#EqualityExpression.
HCPGrammarParserListener.prototype.exitEqualityExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#BitXOrExpression.
HCPGrammarParserListener.prototype.enterBitXOrExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#BitXOrExpression.
HCPGrammarParserListener.prototype.exitBitXOrExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#MultiplicativeExpression.
HCPGrammarParserListener.prototype.enterMultiplicativeExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#MultiplicativeExpression.
HCPGrammarParserListener.prototype.exitMultiplicativeExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#BitShiftExpression.
HCPGrammarParserListener.prototype.enterBitShiftExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#BitShiftExpression.
HCPGrammarParserListener.prototype.exitBitShiftExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#IdentifierNameIndexedArray.
HCPGrammarParserListener.prototype.enterIdentifierNameIndexedArray = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#IdentifierNameIndexedArray.
HCPGrammarParserListener.prototype.exitIdentifierNameIndexedArray = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#IdentifierNameEmptyArray.
HCPGrammarParserListener.prototype.enterIdentifierNameEmptyArray = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#IdentifierNameEmptyArray.
HCPGrammarParserListener.prototype.exitIdentifierNameEmptyArray = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#IdentifierNameOnly.
HCPGrammarParserListener.prototype.enterIdentifierNameOnly = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#IdentifierNameOnly.
HCPGrammarParserListener.prototype.exitIdentifierNameOnly = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#identifierSetProps.
HCPGrammarParserListener.prototype.enterIdentifierSetProps = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#identifierSetProps.
HCPGrammarParserListener.prototype.exitIdentifierSetProps = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#identifierGetProps.
HCPGrammarParserListener.prototype.enterIdentifierGetProps = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#identifierGetProps.
HCPGrammarParserListener.prototype.exitIdentifierGetProps = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#builtInfunction.
HCPGrammarParserListener.prototype.enterBuiltInfunction = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#builtInfunction.
HCPGrammarParserListener.prototype.exitBuiltInfunction = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#CustomFunctionArgumentsExpression.
HCPGrammarParserListener.prototype.enterCustomFunctionArgumentsExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#CustomFunctionArgumentsExpression.
HCPGrammarParserListener.prototype.exitCustomFunctionArgumentsExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#CustomFunctionNamedArgumentExpression.
HCPGrammarParserListener.prototype.enterCustomFunctionNamedArgumentExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#CustomFunctionNamedArgumentExpression.
HCPGrammarParserListener.prototype.exitCustomFunctionNamedArgumentExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#timeExpression.
HCPGrammarParserListener.prototype.enterTimeExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#timeExpression.
HCPGrammarParserListener.prototype.exitTimeExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#timeExpressionOperator.
HCPGrammarParserListener.prototype.enterTimeExpressionOperator = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#timeExpressionOperator.
HCPGrammarParserListener.prototype.exitTimeExpressionOperator = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#arrowExpression.
HCPGrammarParserListener.prototype.enterArrowExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#arrowExpression.
HCPGrammarParserListener.prototype.exitArrowExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#StringLiteralExpression.
HCPGrammarParserListener.prototype.enterStringLiteralExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#StringLiteralExpression.
HCPGrammarParserListener.prototype.exitStringLiteralExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#NumericLiteralExpression.
HCPGrammarParserListener.prototype.enterNumericLiteralExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#NumericLiteralExpression.
HCPGrammarParserListener.prototype.exitNumericLiteralExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#timePeriod.
HCPGrammarParserListener.prototype.enterTimePeriod = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#timePeriod.
HCPGrammarParserListener.prototype.exitTimePeriod = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#timeConstantColonExpression.
HCPGrammarParserListener.prototype.enterTimeConstantColonExpression = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#timeConstantColonExpression.
HCPGrammarParserListener.prototype.exitTimeConstantColonExpression = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#timeConstantColonExpression2.
HCPGrammarParserListener.prototype.enterTimeConstantColonExpression2 = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#timeConstantColonExpression2.
HCPGrammarParserListener.prototype.exitTimeConstantColonExpression2 = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#timeConstantLiteral.
HCPGrammarParserListener.prototype.enterTimeConstantLiteral = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#timeConstantLiteral.
HCPGrammarParserListener.prototype.exitTimeConstantLiteral = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#numericLiteral.
HCPGrammarParserListener.prototype.enterNumericLiteral = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#numericLiteral.
HCPGrammarParserListener.prototype.exitNumericLiteral = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#identifierName.
HCPGrammarParserListener.prototype.enterIdentifierName = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#identifierName.
HCPGrammarParserListener.prototype.exitIdentifierName = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#reservedWord.
HCPGrammarParserListener.prototype.enterReservedWord = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#reservedWord.
HCPGrammarParserListener.prototype.exitReservedWord = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#keyword.
HCPGrammarParserListener.prototype.enterKeyword = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#keyword.
HCPGrammarParserListener.prototype.exitKeyword = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#eos.
HCPGrammarParserListener.prototype.enterEos = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#eos.
HCPGrammarParserListener.prototype.exitEos = function(ctx) {
};


// Enter a parse tree produced by HCPGrammarParser#eos2.
HCPGrammarParserListener.prototype.enterEos2 = function(ctx) {
};

// Exit a parse tree produced by HCPGrammarParser#eos2.
HCPGrammarParserListener.prototype.exitEos2 = function(ctx) {
};



exports.HCPGrammarParserListener = HCPGrammarParserListener;